import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import ordinal from 'ordinal-js';
import Fa from 'react-fontawesome';
import { reduce } from 'lodash';
import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';
import SaleRepsNameRenderer from '../../../../components/table-cells/SaleRepsNameRenderer';
// import ForecastForm from '../forecast-form';
import { getTablePreference } from '../../../App/AppReducer';
import NumberRenderer from '../../../../components/table-cells/NumberRenderer';
import MoneyRenderer from '../../../../components/table-cells/MoneyRenderer';
import TenureRenderer from '../../../../components/table-cells/TenureRenderer';
import BarChartRenderer from '../../../../components/table-cells/BarChartRenderer';
import ClickableNumberRenderer from './ClickableNumberRenderer';
import styles from './styles.css';

const TABLE_NAME = 'leaderboard-table';

class SaleRepTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.handleCellClicked = this.handleCellClicked.bind(this);
  }


  onExitFullScreen() {
    this.props.onExitFullScreen();
  }

  onEnterFullScreen() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getSalesRepColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'name',
      cellRenderer: 'saleRepsNameRenderer',
      cellRendererParams: {
        column,
        displayStatus: true,
        isOwner: true,
      },
    };
  }

  getTenuresColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'tenures',
      cellRenderer: 'tenureRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
      },
    };
  }

  getDealColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'dealCount',
      cellRenderer: 'clickableNumberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        precision: 0,
        onClick: this.handleCellClicked,
      },
    };
  }

  getRequestCountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'dealWithFeedbackRequests',
      cellRenderer: 'clickableNumberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        precision: 0,
        onClick: this.handleCellClicked,
      },
    };
  }

  getRankColumn(column) {
    const total = this.props.owners.length;
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'rank',
      type: 'numericColumn',
      cellRendererParams: {
        column,
      },
      cellClass: (params) => {
        const v = params.value;
        if (v === 1) {
          return styles.textGold;
        } else if (v === 2) {
          return styles.textSilver;
        } else if (v === 3) {
          return styles.textBronze;
        }
        return null;
      },
      valueFormatter: (params) => {
        const v = params.value;
        if (v === 1) {
          return 'Gold';
        } else if (v === 2) {
          return 'Silver';
        } else if (v === 3) {
          return 'Bronze';
        }
        return `${params.value}${ordinal.ordinalSuffix(params.value)} of ${total}`;
      },
    };
  }
  
  getNoRequestCountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'dealWithNoRequests',
      cellRenderer: 'clickableNumberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        precision: 0,
        onClick: this.handleCellClicked,
      },
    };
  }

  getWonAmountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'wonAmount',
      cellRenderer: 'moneyRenderer',
      cellClass: 'text-success text-right',
      type: 'numericColumn',
      cellRendererParams: {
        column,
      },
    };
  }
  getWonCountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'wonCount',
      cellRenderer: 'clickableNumberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        onClick: this.handleCellClicked,
      },
    };
  }

  getAmountWinRateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'amountWinRate',
      cellRenderer: 'numberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        suffix: '%',
        precision: 2,
      },
    };
  }
  getCountWinRateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'countWinRate',
      cellRenderer: 'numberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        suffix: '%',
        precision: 2,
      },
    };
  }

  getRequestPercentColumn(column) {
    const { threshold } = this.props;
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'requestedFeedbackPercent',
      cellRenderer: 'barChartRenderer',
      type: 'numericColumn',
      valueGetter: (params) => {
        if (params && params.data) {
          return params.data.requestedFeedbackPercent * 100;
        }
        return null;
      },
      cellRendererParams: {
        column,
        suffix: '%',
        precision: 1,
        lowerBound: threshold,
        upperBound: ((100 - threshold) / 2),
      },
    };
  }


  getColDefs() {
    const { tableColumns } = this.props;
    return reduce(tableColumns, (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'rank') {
        column = this.getRankColumn(tableColumn);
      } else if (tableColumn.tag === 'salesRep') {
        column = this.getSalesRepColumn(tableColumn);
      } else if (tableColumn.tag === 'deals') {
        column = this.getDealColumn(tableColumn);
      } else if (tableColumn.tag === 'requestCount') {
        column = this.getRequestCountColumn(tableColumn);
      } else if (tableColumn.tag === 'noRequestsCount') {
        column = this.getNoRequestCountColumn(tableColumn);
      } else if (tableColumn.tag === 'wonAmount') {
        column = this.getWonAmountColumn(tableColumn);
      } else if (tableColumn.tag === 'wonCount') {
        column = this.getWonCountColumn(tableColumn);
      } else if (tableColumn.tag === 'amountWinRate') {
        column = this.getAmountWinRateColumn(tableColumn);
      } else if (tableColumn.tag === 'countWinRate') {
        column = this.getCountWinRateColumn(tableColumn);
      } else if (tableColumn.tag === 'tenure') {
        column = this.getTenuresColumn(tableColumn);
      } else if (tableColumn.tag === 'requestPercent') {
        column = this.getRequestPercentColumn(tableColumn);
      } else {
        column = {
          column: tableColumn,
          customFieldType: CUSTOM_FIELD_TYPES.OPPORTUNITY,
        };
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);
  }


  handleCellClicked(field, data) {
    const filters = { owner_id: data.user_id };
    if (field === 'dealWithFeedbackRequests') {
      filters.has_requests = true;
    } else if (field === 'dealWithNoRequests') {
      filters.has_requests = false;
    } else if (field === 'wonCount') {
      filters.stage = 'Won';
    }
    this.props.requestShowDeals(filters);
  }

  renderEmptyMessage() {
    return (
      <div className="alert alert-warning">
        <p><strong><Fa name="exclamation-triangle" /> No records found matching your criteria.</strong></p>
      </div>
    );
  }
  renderTable(opportunities) {
    const { enableFullScreen, fullScreenMode } = this.props;
    const columnDefs = this.getColDefs();


    return (
      <GodTable
        id={TABLE_NAME}
        columnDefs={columnDefs}
        rowData={opportunities}
        onGridReady={this.onGridReady}
        context={{ statUnit: 'Sales Reps' }}
        frameworkComponents={{
          saleRepsNameRenderer: SaleRepsNameRenderer,
          numberRenderer: NumberRenderer,
          moneyRenderer: MoneyRenderer,
          tenureRenderer: TenureRenderer,
          barChartRenderer: BarChartRenderer,
          clickableNumberRenderer: ClickableNumberRenderer,
        }}
        enableFullScreen={enableFullScreen}
        fullScreenMode={fullScreenMode}
        tableManageConfigs={{
          enableCustomMeta: true,
          validObjects: ['User'],
          validCustomMetaObjects: ['User'],
        }}
        resourceType={GodTable.RESOURCE_TYPE.USER}
      />
    );
  }

  render() {
    const {
      owners,
    } = this.props;

    if (owners.length === 0) {
      return this.renderEmptyMessage();
    }

    return (
      <div>
        {owners.length > 0 && this.renderTable(owners)}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    tableColumns: getTablePreference(state, TABLE_NAME),
  };
}

SaleRepTable.propTypes = {
  owners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tableColumns: PropTypes.arrayOf(PropTypes.shape({})),
  enableFullScreen: PropTypes.bool,
  fullScreenMode: PropTypes.bool,
  onExitFullScreen: PropTypes.func,
  threshold: PropTypes.number.isRequired,
  requestShowDeals: PropTypes.func,
};

SaleRepTable.defaultProps = {
  tableColumns: [],
  enableFullScreen: true,
  fullScreenMode: false,
  onExitFullScreen: () => {},
  requestShowDeals: () => {},
};

SaleRepTable.contextTypes = {
};
export default connect(mapStateToProps)(SaleRepTable);
